import { useSearchParams } from "react-router-dom";
import { PageHeader } from "../../components/common";
import { BR, FySelect, Tabs, sel, useBpMeta } from "../../components/bp/BpKit";
import { dshort } from "../../components/bp/WeeklyPo";
import { Winning } from "../../components/bp/Winning";
import { MeetingPlan } from "../../components/bp/MeetingPlan";
import { AskLucy } from "../../components/bp/Lucy";

const WeekSelect = ({ meta, value, onChange }) => (
  <select data-testid="bp-week-select" className={sel} value={value} onChange={(e) => onChange(e.target.value)}>
    {meta.weeks.map((w) => <option key={w.key} value={w.key}>{w.key} · {dshort(w.start)} – {dshort(w.end)}{w.key === meta.current_week && meta.fy === meta.current_fy ? " (this week)" : ""}</option>)}
  </select>
);

export default function WeeklyReview() {
  const [sp, setSp] = useSearchParams();
  const meta = useBpMeta(sp.get("fy") || undefined);
  if (!meta) return null;
  const set = (kv) => setSp((p) => { const n = new URLSearchParams(p); Object.entries(kv).forEach(([k, v]) => (v ? n.set(k, v) : n.delete(k))); return n; });
  const week = sp.get("week") || (meta.fy === meta.current_fy ? meta.current_week : "W01");
  const tab = sp.get("tab") || "winning", branch = sp.get("branch") || "";
  return (
    <div className="space-y-6" data-testid="bp-week-page">
      <PageHeader eyebrow="BP & Planning" title="Weekly review" desc="The winning sheet and meeting plan for one BP week (Saturday to Friday). Calls, emails, WhatsApp and meetings are counted from what's logged in Axiom One.">
        <FySelect meta={meta} value={meta.fy} onChange={(v) => set({ fy: v, week: "" })} />
        <WeekSelect meta={meta} value={week} onChange={(v) => set({ week: v })} />
        {meta.branches.length > 1 && (
          <select data-testid="bp-week-branch-select" className={sel} value={branch} onChange={(e) => set({ branch: e.target.value })}>
            <option value="">All branches</option>
            {meta.branches.map((b) => <option key={b} value={b}>{BR[b]}</option>)}
          </select>
        )}
        <AskLucy />
      </PageHeader>
      <Tabs tid="bp-week-tabs" value={tab} onPick={(k) => set({ tab: k })} items={[["winning", "Winning sheet"], ["meetings", "Meeting plan"]]} />
      {tab === "winning" ? <Winning meta={meta} week={week} branch={branch} /> : <MeetingPlan meta={meta} week={week} branch={branch} />}
    </div>
  );
}
